import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';

function Navigation() {
  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="logo">
          <img 
            src={require('../assets/vinland-logo.png')} 
            alt="Vinland Logo" 
            className="nav-logo-image"
          />
        </Link>
        <ul className="nav-menu">
          <li><Link to="/collections">Collections</Link></li>
          <li><Link to="/about">About</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
